import $ from 'jquery';
import favorites from '../favorites/favorites';
import { __esModule } from 'swup/lib/modules/updateTransition';

window.addEventListener('px-ready',function() {
    $('.js-print').click(function(e){
        e.preventDefault();
        if ($(this).data('no-prevent')) {
            window.open($(this).attr('href'), '_blank');
            return;
        }
        var  href = $(this).attr('href'), $link = $(this), $iframe = $('iframe[src="'+href+'"]');
        function printPdf() {
            var frameContent = ($iframe[0].contentWindow || $iframe[0].contentDocument || $iframe[0].window);
            try {
                frameContent.print();
            } catch (e) {
                $link.data('no-prevent', true);
                $link.trigger('click');
            }
        }
        if (!$iframe.length) {
            $iframe = $('<iframe src="'+href+'" style="position:absolute;bottom:100%;pointer-events:none;opacity:0;visibility:hidden;"></iframe>');
            $('body').append($iframe);
            $iframe.load(printPdf);
        } else {
            printPdf();
        }
    });
    $('.like').on('click', function(e) {
        e.preventDefault();
        var tthis = $(this);
        if(tthis.parent().attr('data-lock') != 1){
            tthis.parent().attr('data-lock',1);
            window.setTimeout(function(){tthis.parent().attr('data-lock',0);},100);
            var id = tthis.data('id');
            if (tthis.hasClass('is-liked')) {
                favorites.remove(id);
                tthis.removeClass('is-liked');
            } else {
                favorites.add(id);
                tthis.addClass('is-liked');
            }
            //$(this).toggleClass('is-liked');
        }
    });
    /*$('.product-accordions-print li').each(function(){
        $(this).height($(this).height());
    })*/
})
